import { render, staticRenderFns } from "./SystemMessageItem.vue?vue&type=template&id=733f82f9&scoped=true&"
import script from "./SystemMessageItem.vue?vue&type=script&lang=js&"
export * from "./SystemMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageItem.vue?vue&type=style&index=0&id=733f82f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733f82f9",
  null
  
)

export default component.exports